<i18n>
{
  "fr": {
    "CompletedWork": "Completed Work",
    "ID": "ID",
    "OriginalEstimate": "Original Estimate",
    "ProjectName": "Nom de projet",
    "Velocity": "Vélocité",
    "TasksInError": "Nombre de tâches en erreur",
    "Title": "Titre"
  }
}
</i18n>

<template>
  <section v-if="projectTasks">
    <div class="row mb-2">
      <div class="col-sm">
        <h4>
          {{ $t('ProjectName') }} :
          <span class="font-weight-bold">
            {{ projectTasks.projectName }}
          </span>
        </h4>
      </div>
      <div class="col-sm">
        <h4>
          {{ $t('Velocity') }} :
          <span class="font-weight-bold">
            {{ projectTasks.velocity | percentage }}
          </span>
        </h4>
      </div>
      <div class="col-sm">
        <h4>
          {{ $t('TasksInError') }} :
          <span class="font-weight-bold">
            {{ projectTasks.tasksInError }}
          </span>
        </h4>
      </div>
    </div>
    <hr>
    <table class="table table-bordered table-striped">
      <thead class="thead-dark">
        <tr>
          <th scope="col">{{ $t('ID') }}</th>
          <th scope="col">{{ $t('Title') }}</th>
          <th scope="col">{{ $t('OriginalEstimate') }}</th>
          <th scope="col">{{ $t('CompletedWork') }}</th>
          <th scope="col">{{ $t('Velocity') }}</th>
        </tr>
      </thead>
      <tbody
        v-on="$listeners">
        <tr
          v-for="task in projectTasks.tasks"
          :key="task.id"
          :class="{ 'bg-danger-light': task.originalEstimate <= 0 }">
          <td scope="row">{{ task.id }}</td>
          <td>{{ task.title }}</td>
          <td>{{ task.originalEstimate }}</td>
          <td>{{ task.completedWork }}</td>
          <td
            :class="{
              'bg-primary': task.velocity <= 1 && task.velocity >= 0.95,
              'bg-success': task.velocity < 0.95 && task.velocity >= 0.90,
              'bg-warning': task.velocity < 0.90 && task.velocity >= 0.85,
              'bg-danger': task.velocity < 0.85 && task.velocity > 0,
            }"
          >{{ task.velocity | percentage }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('tasks', ['projectTasks']),
  },
  created() {
    this.$store.commit('tasks/loadedProject', this.$route.params.projectName);
  },
};
</script>
